import { ReducerCreators } from '@reduxjs/toolkit';
import { AudiencesState } from '../types';

export const setAllAttendeesLoading = (create: ReducerCreators<AudiencesState>) =>
  create.reducer((state) => {
    state.allAttendees.loading = true;
  });
